<!-- <link rel="stylesheet" href="https://unpkg.com/@progress/kendo-font-icons/dist/index.css" /> -->

<div class="container-fluid" style="padding: 40px;" #appendTo>
  <div class="row">
    <div class="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2"
      style="margin-left: auto; margin-right: auto; max-width: 765px;">
      <!-- <h3 style="text-align: left;">Contact Us</h3> -->
      <div style="margin-bottom: 100px;">

        <!-- @if(messageState===MessageStates.Before){
    <div class="col-11">
      <div class="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2"
        style="margin-left: auto; margin-right: auto; max-width: 765px;">
        <div class="d-none d-md-block">
          <h2 style="text-align: center;font-size:32px">Questions or comments?</h2>
          <h2 style="text-align: center;margin-bottom: 50px; font-size:32px">Get in touch, we’d love to hear from you!
          </h2>
        </div>

        <div class="d-none d-sm-block d-md-none">
          <h2 style="text-align: center;">Questions or comments?</h2>
          <h2 style="text-align: center;margin-bottom: 50px;">Get in touch, we’d love to hear from you!
          </h2>
        </div>

        <div class="d-block d-sm-none">
          <h3 style="text-align: center">Questions or comments?</h3>
          <h3 style="text-align: center;margin-bottom: 30px;">Get in touch, we’d love to hear from you!
          </h3>
        </div>
      </div>
    </div>
    }
  </div> -->

        @if(messageState===MessageStates.Before){
        <div class="row">
          <div style="margin-bottom: 100px;">

            <!-- <form [formGroup]="contactForm" (ngSubmit)="onSubmit()"> -->
            <form [formGroup]="contactForm">

              <div class="row">
                <div class="col-md-6 col-sm-12 p-2">
                  <input type="text" class="form-control" formControlName="firstName" id="firstName"
                    placeholder="FIRST NAME">
                </div>
                <div class="col-md-6 col-sm-12 p-2">
                  <input type="text" class="form-control" formControlName="lastName" id="lastname"
                    placeholder="LAST NAME">
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 col-sm-12 p-2">
                  <input type="text" class="form-control" id="email" placeholder="EMAIL*" formControlName="email"
                    class="form-control">
                  <div *ngIf="email?.invalid" class="alert alert-danger">
                    <div *ngIf="email?.errors?.['required']">
                      Email address is required.
                    </div>
                    <div *ngIf="email?.errors && email?.errors?.['email']">Please, enter valid email address.</div>
                  </div>
                </div>
                <div class="col-md-6 col-sm-12 p-2">
                  <input type="text" class="form-control" name="phone" formControlName="phone" id="phone"
                    placeholder="PHONE NUMBER">
                  <div *ngIf="phone?.invalid && (phone?.dirty || phone?.touched)" class="alert alert-danger">
                    <div *ngIf="phone?.errors?.['invalidPhoneValidator']">Invalid Phone Number</div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col p-2">
                  <textarea rows="8" class="form-control" formControlName="message" id="message"
                    placeholder="YOUR ENQUIRY*"></textarea>
                  <div *ngIf="message?.invalid" class="alert alert-danger">

                    <div *ngIf="message?.errors?.['required']">
                      You must enter a message.
                    </div>
                  </div>

                </div>
              </div>
              @if (showCaptcha) {

              <div class="row">
                <div class="col p-2">
                  <captcha-required formControlName="captchaValid" [setFocus]="focusCounter"
                    (change)="captchaHandler($event)"></captcha-required>
                </div>
              </div>

              <div class="row">
                <div class="col-9 p-2">
                  <div *ngIf="captchaValid?.invalid" class="alert alert-danger">

                    <div *ngIf="captchaValid?.errors?.['required']">
                      Captcha text required.
                    </div>
                  </div>
                </div>

              </div>

              <div class="row">
                <div class="col">
                  <button class="btn btn-primary" type="submit" [disabled]="contactForm.invalid" (click)="onSubmit()">
                    <fa-icon icon="envelope"></fa-icon> Submit</button>
                </div>
              </div>

              }
              @else {

              <div class="row">
                <div class="col">
                  <button class="btn btn-primary" type="submit" [disabled]="contactForm.invalid"
                    (click)="sendClicked()">
                    <fa-icon icon="envelope"></fa-icon> SEND</button>
                </div>
              </div>
              }
              <!-- <pre>
          contactForm.invalid: {{contactForm.invalid}}<br>
        </pre>
        <pre>{{ contactForm.errors | json }}</pre> -->
            </form>
          </div>
        </div>

        }
        @if(messageState === MessageStates.After){
        <div>
          <div class="message-sent">
            <img src="assets/images/envelope.png" style="margin-bottom: 30px;" />
            <h2>Message Sent!</h2>
            <br><br>
            <h4>Thank you for your enquiry. We will get back to you soon.</h4>
            <br><br>
            <button type="button" class="btn btn-link" (click)="resetForm()"> Send another message.</button>

            <!-- <a href ng-click="resetForm()" style="text-decoration: underline;">Send another message.</a> -->
          </div>
        </div>
        }

        @if(messageState===MessageStates.InProgress){
        <div>
          <div class="message-sent">
            <i class="fa fa-spinner fa-pulse fa-4x" aria-hidden="true"></i>
            <h2>Sending Message...</h2>
          </div>
        </div>
        }

        @if(messageState===MessageStates.Error){
        <div>
          <div class="message-sent">
            <h2 style="margin-bottom: 30px;">An error occurred sending the email</h2>
            <h4 style="margin-bottom: 30px;">Please try again later</h4>
            <a class="btn btn-stn" href="/">Go to homepage</a>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>
